// type – true тексты для средних, false – для младших
export default (type = true) => [
  {
    image: require('./item1.svg'),
    imageFound: require('./item1.found.svg'),
    x: 0.7868055556,
    y: 0.6611111111,
    found: false,
    hasRightAnswer: false,
    domID: 'smart_watches',
    animation: require('./json/Street_SmartWatch.json'),
    about: [
      {
        title: 'Какие данные может собирать умный браслет?',
        text: type
          ? 'Маршрут человека: где он чаще бывает? \n\n Показатели здоровья: много ли человек ходит, ровно ли бьётся его сердце?'
          : 'Показатели здоровья: много ли человек ходит, ровно ли бьётся его сердце?',
      },
      {
        title: 'Как можно использовать эти данные?',
        text: type
          ? 'Зная, куда человеку интереснее ходить (например, в парк или в кино), предлагаем ему афишу мероприятий по его интересам. \n\n Предупреждаем о рисках для здоровья. А если вдруг у человека будет сердечный приступ — вызываем скорую помощь и спасаем ему жизнь!'
          : 'Предупреждаем людей о рисках для их здоровья. А если вдруг у человека случится сердечный приступ – вызываем скорую и спасаем ему жизнь!',
      },
    ],
    question: 'Как умный браслет может спасти жизнь?',
    answers: [
      {
        id: 0,
        text: 'Создать защитное поле.',
        isCorrect: false,
      },
      {
        id: 1,
        text: 'Защитить от солнечного удара.',
        isCorrect: false,
      },
      {
        id: 2,
        text: 'Измерять пульс и вызвать при необходимости «скорую».',
        isCorrect: true,
      },
      {
        id: 3,
        text: 'Предлагать удобный маршрут.',
        isCorrect: false,
      },
    ],
  },
  {
    image: require('./item2.svg'),
    imageFound: require('./item2.found.svg'),
    x: 0.6465277778,
    y: 0.10048889,
    found: false,
    hasRightAnswer: false,
    domID: 'antenna',
    animation: require('./json/Street_Antenna.json'),
    about: [
      {
        title: 'Какие данные может собирать вышка сотовой связи?',
        text: type
          ? 'Сколько телефонов в данный момент времени подключено к этой вышке? Сколько было подключено в этот же день год назад? \n\n Какой уровень сигнала у подключённых устройств? Как часто пользователь теряет сеть?'
          : 'Сколько телефонов в данный момент подключено к этой вышке? Сколько было подключено в этот же день год назад? \n\n Какой уровень сигнала у подключённых устройств? Как часто пользователь теряет сеть?',
      },
      {
        title: 'Как можно использовать эти данные?',
        text: type
          ? 'Знаем, где сеть перегружена и как быстро в этой точке растёт нагрузка – установим более мощные передатчики \n\n Находим «слепые зоны», где связь нестабильная, и исправляем ситуацию.'
          : 'Знаем, где сеть перегружена и как быстро в этой точке растёт нагрузка – установим более мощные передатчики. \n\n Находим «слепые зоны», где связь неустойчивая, и исправляем ситуацию.',
      },
    ],
    question: 'Какие данные НЕ может собирать вышка сотовой связи?',
    answers: [
      {
        id: 0,
        text: 'Количество подключённых абонентов.',
        isCorrect: false,
      },
      {
        id: 1,
        text: 'Частоту случаев потери связи абонентами.',
        isCorrect: false,
      },
      {
        id: 2,
        text: 'Максимальный уровень нагрузки на сеть за день.',
        isCorrect: false,
      },
      {
        id: 3,
        text: 'Количество выключенных телефонов в зоне действия вышки.',
        isCorrect: true,
      },
    ],
  },
  {
    image: require('./item3.svg'),
    imageFound: require('./item3.found.svg'),
    x: 0.6319444444,
    y: 0.3331,
    found: false,
    hasRightAnswer: false,
    domID: 'traffic_light',
    animation: require('./json/Street_Lights.json'),
    about: [
      {
        title: 'Какие данные может собирать светофор?',
        text: type
          ? 'Сколько пешеходов переходит дорогу на красный свет? На каком из перекрёстков города пешеходы-нарушители встречаются чаще всего? \n\n Как долго машины стоят на красный свет на этом светофоре? Возникают ли там пробки?'
          : 'Как долго машины стоят на красный свет на этом светофоре? Собираются ли на нём  пробки?',
      },
      {
        title: 'Как можно использовать эти данные?',
        text: type
          ? 'Находим перекрёстки, где пешеходы часто переходят на запрещающий сигнал, строим в этих местах подземные переходы. \n\n Настраиваем работу светофоров: что случится, если на каком-то светофоре образовалась  большая пробка, а потом мы дали машинам  зелёный свет? Вся “пробка” переедет к следующему  светофору! Но если мы знаем где, когда и сколько машин стоят на всех светофорах в “пробках”, мы можем настроить их работу так, чтобы включилась “зелёная волна” и машины беспрепятственно проехали через  ряд перекрёстков, а движение постепенно  нормализовалось.'
          : 'Если мы знаем где, когда и сколько машин стоят на всех светофорах, мы можем настроить их работу так, чтобы включилась «зелёная волна» и машины беспрепятственно проехали  через ряд светофоров,  а движение постепенно нормализовалось',
      },
    ],
    question: 'Как «умный» светофор поможет городу?',
    answers: [
      {
        id: 0,
        text: 'Будет уворачиваться от автомобилей.',
        isCorrect: false,
      },
      {
        id: 1,
        text: 'Никак.',
        isCorrect: false,
      },
      {
        id: 2,
        text: 'Соберёт информацию о дорожном движении и поможет уменьшить пробки.',
        isCorrect: true,
      },
      {
        id: 3,
        text: 'Всегда будет включать пешеходам только зелёный свет.',
        isCorrect: false,
      },
    ],
  },
  {
    image: require('./item4.svg'),
    imageFound: require('./item4.found.svg'),
    x: 0.09202083333,
    y: 0.10922222222,
    found: false,
    hasRightAnswer: false,
    domID: 'cameras',
    animation: require('./json/Street_SpeedCamera.json'),
    about: [
      {
        title: 'Какие данные может собирать дорожная камера?',
        text: type
          ? 'Автомобильные номера нарушителей.\n\nФиксировать участки дороги, где чаще всего случаются нарушения. Время суток, когда  чаще всего случаются нарушения.'
          : 'На каком участке дороги чаще всего случаются нарушения? В какое время суток чаще всего происходят нарушения?',
      },
      {
        title: 'Как можно использовать эти данные?',
        text: type
          ? 'Определяем нарушителей движения, высылаем им штрафы.\n\nУзнаём про участки дорог, где чаще всего случаются нарушения, вводим новые скоростные режимы и устанавливаем лежачих полицейских, чтобы помешать разгоняться.'
          : 'Узнаём про участки дорог, где чаще всего случаются нарушения, вводим новые скоростные режимы и устанавливаем лежачих полицейских, чтобы помешать разгоняться.',
      },
    ],
    question: 'Какие данные может собирать дорожная камера?',
    answers: [
      {
        id: 0,
        text: 'Сколько людей в городе имеют машины?',
        isCorrect: false,
      },
      {
        id: 1,
        text: 'Почему люди забывают пристёгиваться ремнями безопасности?',
        isCorrect: false,
      },
      {
        id: 2,
        text: 'Какая максимально возможная скорость автомобиля?',
        isCorrect: false,
      },
      {
        id: 3,
        text: 'Как часто водители нарушают скоростной режим в выходные дни?',
        isCorrect: true,
      },
    ],
  },
  {
    image: require('./item4.svg'),
    imageFound: require('./item5.found.svg'),
    x: 0.09202083333,
    y: 0.10922222222,
    found: false,
    hasRightAnswer: false,
    domID: 'bus_stop',
    animation: require('./json/Street_BusStop.json'),
    about: [
      {
        title: 'Какие данные может собирать остановка?',
        text: type
          ? 'В какое время дня  на остановке скапливается больше всего человек? Как долго они ждут свой автобус?\n\nСколько пассажиров едут с велосипедами?'
          : 'В какое время дня на остановке больше всего человек? Как долго они ждут свой автобус?',
      },
      {
        title: 'Как можно использовать эти данные?',
        text: type
          ? 'Направляем автобусы по маршрутам, где наблюдается наибольшее скопление пассажиров!\n\nТам, где велосипедистов особенно много, запускаем автобусы, имеющие площадку  для перевозки велосипедов.'
          : 'Направляем автобусы по маршрутам, где наблюдается наибольшее скопление пассажиров!',
      },
    ],
    question: 'Какие данные может собирать остановка?',
    answers: [
      {
        id: 0,
        text: 'Число пассажиров.',
        isCorrect: true,
      },
      {
        id: 1,
        text: 'Настроение пассажиров.',
        isCorrect: false,
      },
      {
        id: 2,
        text: 'Причины, по которым люди путешествуют автобусами.',
        isCorrect: false,
      },
      {
        id: 3,
        text: 'Число людей, НЕ пользующихся общественным транспортом.',
        isCorrect: false,
      },
    ],
  },
  {
    image: require('./item4.svg'),
    imageFound: require('./item6.found.svg'),
    x: 0.09202083333,
    y: 0.10922222222,
    found: false,
    hasRightAnswer: false,
    domID: 'icecream_shop',
    animation: require('./json/Street_Icecream.json'),
    about: [
      {
        title: 'Какие данные может собирать фургончик с мороженым?',
        text: type
          ? 'Какие виды мороженого покупают чаще всего в этом районе? \n\n Какие фургончики в городе продали больше всего мороженого?'
          : 'Какие виды мороженого покупают чаще всего в этом районе? \n\n Какие фургончики в городе продали больше всего мороженого?',
      },
      {
        title: 'Как можно использовать эти данные?',
        text: type
          ? 'Выставляем на продажу те виды мороженого, которые покупают чаще всего. \n\n Расставляем фургончики в тех районах, где на мороженое наибольший спрос.'
          : 'Выставляем на продажу те виды мороженого, которые покупают чаще всего. \n\n Расставляем фургончики в тех районах, где на мороженое наибольший спрос.',
      },
    ],
    question: 'На какие вопросы НЕ сможет ответить мороженщик, собирая данные о продажах мороженого через фургончики?',
    answers: [
      {
        id: 0,
        text: 'Надо ли установить дополнительный фургончик в парке развлечений?',
        isCorrect: false,
      },
      {
        id: 1,
        text: 'Почему летом покупают больше мороженого, чем зимой?',
        isCorrect: true,
      },
      {
        id: 2,
        text: 'Каких видов мороженого лучше сделать больше: клубничного или шоколадного?',
        isCorrect: false,
      },
      {
        id: 3,
        text: 'Какое мороженое лучше продаётся: в вафельных рожках или в стаканчиках?',
        isCorrect: false,
      },
    ],
  },
]
